import axios from '@/utils/http'

/**
 *获取用户列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getUserList (params) {
  return axios({
    url: '/AccountManageService/UserManage/GetUsers',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *添加用户
 *
 * @export
 * @param {*} params
 * @returns
 */
export function addUser (params) {
  return axios({
    url: '/AccountManageService/UserManage/AddUser',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 *修改用户
 *
 * @export
 * @param {*} params
 * @returns
 */
export function editUser (params) {
  return axios({
    url: '/AccountManageService/UserManage/EditUser',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 *获取角色列表
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getRoleList (params) {
  return axios({
    url: '/AccountManageService/UserManage/GetRoles',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *修改用户
 *
 * @export
 * @param {*} params
 * @returns
 */
export function setUserRoles (params) {
  return axios({
    url: '/AccountManageService/UserManage/SetUserRoles',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 *获取用户角色
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getUserRoles (params) {
  return axios({
    url: '/AccountManageService/UserManage/GetUserRoles',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *职工管理
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getWorkerList (params) {
  return axios({
    url: '/AccountManageService/WorkerManage/GetWorkers',
    method: 'get',
    params: {
      ...params
    }
  })
}
